import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-spring';
import plus from '../assets/plus.svg';
import socialList from '../assets/socialsLinks';
import { Wrapper, PlusButton, SocialLink, SocialLinkWrapper } from '../styles/Socials';
// import Breakpoint from './Breakpoint';

class Socials extends React.Component {
  static propTypes = {
    notStatic: PropTypes.bool,
  };

  static defaultProps = {
    notStatic: false,
  };

  state = {
    socialIsOpen: false,
  };

  toggleSocials = () => {
    const { socialIsOpen } = this.state;
    this.setState({ socialIsOpen: !socialIsOpen });
  };

  render() {
    const { notStatic } = this.props;
    const { socialIsOpen } = this.state;
    return (
      <Wrapper notStatic={notStatic} centerInPage>
        {
          <Transition
            items={socialList}
            from={{ opacity: 0, position: 'absolute' }}
            enter={{ opacity: 1, position: 'static' }}
            leave={{ opacity: 0, position: 'absolute' }}
            keys={socialList.map(social => social.name)}
            delay={50}
          >
            {socialIsOpen &&
              socialList.map(social => styles => (
                <SocialLinkWrapper style={styles} key={social.name}>
                  <SocialLink href={social.link} target={social.target || ''}>
                    <img src={social.image} alt={social.name} />
                  </SocialLink>
                </SocialLinkWrapper>
              ))}
          </Transition>
        }

        <PlusButton onClick={this.toggleSocials}>
          <img src={plus} alt="Open Links" />
        </PlusButton>
      </Wrapper>
    );
  }
}

export default Socials;
